import React from 'react';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { Card } from '../ui';
import { fmtDate } from '../api';
import { LEVEL_COLORS, TFlag } from './parts';

const SRC = { farnesina: 'Farnesina', us: 'U.S. State Dept.' };

function Pill({ l }) {
  return <span className="inline-grid place-items-center w-6 h-6 rounded-sm text-[11px] font-bold text-white" style={{ background: LEVEL_COLORS[l] || '#2A2F36' }}>{l ?? '–'}</span>;
}

export default function LevelChanges({ items, onOpen, compact = false }) {
  return (
    <Card className="p-6 mb-4" data-testid="travel-changes">
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] mb-1">Ultimi cambi di fascia di rischio</p>
      <p className="text-xs text-[#5A5F67] mb-4">Variazioni rilevate da BOND sulle indicazioni Farnesina e avvisi del Dipartimento di Stato USA (livelli 1-4).</p>
      {items.length === 0 && <p className="text-sm text-[#8A8F97]" data-testid="travel-changes-empty">Nessun cambio di fascia registrato finora.</p>}
      <div className={compact ? '' : 'grid md:grid-cols-2 gap-x-6'}>
        {items.slice(0, compact ? 8 : 12).map((c) => {
          const up = c.to > c.from;
          const Icon = up ? ArrowUpRight : ArrowDownRight;
          return (
            <button key={c.id} onClick={() => c.iso3 && onOpen(c.iso3)} className="w-full grid grid-cols-[28px_minmax(0,1fr)_auto] gap-3 items-center py-2.5 border-t border-[#1F242C] text-left hover:bg-[#D4AF37]/5 transition-colors" data-testid={`travel-change-${c.id}`}>
              <TFlag iso2={c.iso2} />
              <span className="min-w-0">
                <span className="block text-sm text-[#F2F2F2] truncate">{c.name}</span>
                <span className="block text-[11px] text-[#5A5F67]">{SRC[c.source] || c.source} · {fmtDate(c.date)}</span>
              </span>
              <span className="flex items-center gap-1.5">
                <Pill l={c.from} /><Icon size={14} className={up ? 'text-[#E37A72]' : 'text-[#2E9E6A]'} /><Pill l={c.to} />
              </span>
            </button>
          );
        })}
      </div>
    </Card>
  );
}
